export class RequestView {
  locIds: number[];
  pageNo: number;
  pageSize: number;
  fromDate: string;
  toDate: string;
  serviceMan: number[];
  paymentType: string[];
  currentStatus: string[];
  locId: number;
  status: string;
  assetId: number[];
  offerBy: string;

  // Shipping Expenses
  statuses: string[];
  serviceMans: string[];

  // Expense management
  fromDateClaim: string;
  toDateClaim: string;
  fromDateApprove: string;
  toDateApprove: string;
  fromDateAllowed: string;
  toDateAllowed: string;
  subModules: string[];
  modules: string[];
  reason: string[];
  userId: string;
  userIds: string[];
  appVersions: string[];
  androidVersions: string[];
  date: string;
  activeStatus: any;
  riderStatus: boolean[];
  beforeTime: string;

  durationType: string;
  selectedLoc: number[];
  sourceType: string[];
  paymentMode: string;

}